import React, { ReactNode, memo } from "react";
import BaseNode, { NodeInput, NodeOutput, contentStyle as style } from "./BaseNode";
import { Connection, Handle, Position } from "reactflow";
/*import { allowedConnections } from "../config/config-designer";*/
import useDesigner from "../../../hooks/useDesigner";
import { Node as NodeType } from 'reactflow';
import { NodeTypes } from "../../../config/node-types";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { connect } from "http2";

export type Data = {
    name: string,
    color: string,
    nodeType: NodeTypes,
    inputs: NodeInput[],
    outputs: NodeOutput[]    
};

//export type FunctionData = Data & {    
//    isFunction: boolean,
//    functionId: string,
//    functionDescription: string,    
//};

const singletonNodeTypes = [
    'questionNode',
    'answerNode',
    'captureResponseNode',
    'imageNode',
    'prmoptNode'
]

const isValidInput = (connection: Connection, type: string, data: Data, destNode: NodeType): boolean => {
    const sourceHandleType = connection.targetHandle?.replace('inp_', '') as NodeTypes;
    const destHandleType = connection.sourceHandle?.replace('src_', '') as NodeTypes
    const destNodeType = destNode.type as NodeTypes;

    //const sourceNodeDetails = allowedConnections[data.nodeType];
    //const destNodeDetails = allowedConnections[destNodeType];

    return true;
    //return destNodeDetails.outputs.some(p => p.destHandleType == destHandleType && p.sourceHandleType === sourceHandleType && p.sourceNodeType == data.nodeType);
};
const isValidOutput = (connection: Connection, type: string, data: Data, destNode: NodeType): boolean => {
    const destHandleType = connection.targetHandle?.replace('inp_', '') as NodeTypes
    const sourceHandleType = connection.sourceHandle?.replace('src_', '') as NodeTypes
    const destNodeType = destNode.type as NodeTypes

    //const sourceNodeDetails = allowedConnections[data.nodeType];
    //const destNodeDetails = allowedConnections[destNodeType];

    return true;
    //return destNodeDetails.inputs.some(p => p.destHandleType == destHandleType && p.sourceHandleType === sourceHandleType && p.sourceNodeType == data.nodeType);
};

type Props = {
    data: Data,
    selected: boolean,
    children?: ReactNode,
    nodeId: string,
    hidePrompts?: boolean,
    hideHeading?: boolean
}

const InputOutputNode = ({ data, selected, children, nodeId, hidePrompts = false, hideHeading = false }: Props) => {
    const { nodes } = useDesigner();

    return (
        <BaseNode
            hideHeading={hideHeading}
            label={data.name}
            selected={selected}
            color={data.color}
            content={
                <>
                    {children}

                    <div
                        style={{ ...style.io }}
                    >
                        <Handle
                            type="target"
                            position={Position.Left}
                            id={'inp_playNode'}
                            style={{ ...style.handle, backgroundColor: 'white' }}
                            isValidConnection={(connection: Connection) => {
                                const destNode = nodes.find(s => s.id === connection.source);

                                if (!destNode) return false;

                                return connection.sourceHandle === "src_playNode" && connection.targetHandle === "inp_playNode";
                            }}
                        >
                            <PlayArrowIcon style={{ fontSize: 18, pointerEvents: 'none' }} />
                        </Handle>

                        <Handle
                            type="source"
                            position={Position.Right}
                            id={'src_playNode'}
                            style={{ ...style.nextHandle, backgroundColor: 'white', ...style.right, }}
                            isValidConnection={(connection: Connection) => {
                                const destNode = nodes.find(s => s.id === connection.source);

                                if (!destNode) return false;

                                return connection.sourceHandle === "src_playNode" && connection.targetHandle === "inp_playNode";
                            }}
                        >
                            <PlayArrowIcon style={{ fontSize: 18, pointerEvents: 'none' }} />
                        </Handle>
                    </div>

                    {data.inputs.map((input: NodeInput) => (
                        <div
                            key={"i-" + input.label}
                            style={{ ...style.io, ...style.textLeft }}
                        >
                            {input.label}
                            <Handle
                                type="target"
                                position={Position.Left}
                                id={'inp_' + input.type}
                                style={{ ...style.handle, backgroundColor: input.inputColor }}
                                isValidConnection={(connection: Connection) => {
                                    const destNode = nodes.find(s => s.id === connection.source);

                                    if (!destNode) return false;

                                    return isValidInput(connection, input.type, data, destNode)
                                }}
                            />
                        </div>
                    ))}
                    {data.outputs.length > 0 && <div style={style.contentHeader}>{"Outputs"}</div>}


                    {data.outputs.map((output: NodeOutput) => (
                        <div
                            key={"o-" + output.label}
                            style={{ ...style.io, ...style.textRight }}
                        >
                            {output.label}
                            <Handle
                                type="source"
                                position={Position.Right}
                                id={'src_' + output.type}
                                style={{ ...style.handle, ...style.right, backgroundColor: output.outputColor }}
                                isValidConnection={(connection) => {
                                    const destNode = nodes.find(s => s.id === connection.target);

                                    if (!destNode) return false;

                                    return isValidOutput(connection, output.type, data, destNode)
                                }}
                            />
                        </div>
                    ))}
                </>
            }
        />
    );
};

export default memo(InputOutputNode);
